import * as types from './mutation-types';
import {
	SEARCH_PARAMS,
	SELECTED_ROW,
	STATE_PARAMS,
	FORM_DATA,
	JGMT_RESULT_DATA,
	PAGING_INFO,
	RE_INS_POPUP_PARAMS,
	SEARCH_BARCODE_RESULT
} from './state';

export default {
	[types.STATE_INIT]: state => {
		state.isSaved = false;
		state.searchParams = SEARCH_PARAMS();
		state.selectedRow = SELECTED_ROW();
		state.stateParams = STATE_PARAMS();
		state.resultList = [];
		state.formInfo = FORM_DATA();
		state.jgmtReslutList = JGMT_RESULT_DATA();
		state.resultPopupList = [];
		state.pagingInfo = PAGING_INFO();
		state.resultPopupCommList = [];
		state.reInsPopupParams = RE_INS_POPUP_PARAMS();
		state.searchBarcodeResult = SEARCH_BARCODE_RESULT();
	},
	[types.SEARCH_POPUP_STATE_INIT]: state => {
		state.resultPopupList = [];
		state.pagingInfo = PAGING_INFO();
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.SEARCH_BARCODE_RESULT]: (state, { key, value }) => {
		state.searchBarcodeResult[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SELECTED_ROW]: (state, { key, value }) => {
		state.selectedRow[key] = value;
	},
	[types.SET_FORM]: (state, { key, value }) => {
		state.formInfo[key] = value;
	},
	[types.STATE_PARAM]: (state, { key, value }) => {
		state.stateParams[key] = value;
	},
	[types.RE_INS_POPUP_PARAMS]: (state, { key, value }) => {
		state.reInsPopupParams[key] = value;
	},
	[types.GRID_ROW_INIT]: state => {
		let list = state.resultList;
		for (let i = 0; i < list.length; i++) {
			state.resultList[i].avgVal = '';
			state.resultList[i].stdDvatVal = '';
			state.resultList[i].powAbltVal = '';
			state.resultList[i].x1 = '';
			state.resultList[i].x2 = '';
			state.resultList[i].x3 = '';
			state.resultList[i].x4 = '';
			state.resultList[i].x5 = '';
			state.resultList[i].x6 = '';
			state.resultList[i].x7 = '';
			state.resultList[i].x8 = '';
			state.resultList[i].x9 = '';
			state.resultList[i].x10 = '';
		}
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.SEARCH_POPUP_COMM_INIT]: state => {
		state.resultPopupCommList = [];
		state.resultPopupList = [];
		state.pagingInfo = PAGING_INFO();
	},
	[types.BARCODE_SEARCH_INIT]: state => {
		state.isSaved = false;
		// state.searchParams = SEARCH_PARAMS();
		state.selectedRow = SELECTED_ROW();
		state.stateParams = STATE_PARAMS();
		state.resultList = [];
		state.formInfo = FORM_DATA();
		state.jgmtReslutList = JGMT_RESULT_DATA();
		state.resultPopupList = [];
		state.pagingInfo = PAGING_INFO();
		state.resultPopupCommList = [];
		state.reInsPopupParams = RE_INS_POPUP_PARAMS();
		// state.searchBarcodeResult = SEARCH_BARCODE_RESULT();
	}
};
